import { z } from 'zod';
import { JwtPayloadSchema, emailField } from './user.js';

export const RefreshTokenSchema = z.object({
  refreshToken: z.string().min(1, 'Refresh token requerido'),
});
export type RefreshTokenInput = z.infer<typeof RefreshTokenSchema>;

export const AuthResponseSchema = z.object({
  token: z.string(),
  refreshToken: z.string(),
  user: JwtPayloadSchema,
});
export type AuthResponse = z.infer<typeof AuthResponseSchema>;

export const ResetPasswordSchema = z.object({
  password: z.string().min(8, 'Minimo 8 caracteres'),
});
export type ResetPasswordInput = z.infer<typeof ResetPasswordSchema>;

export const RequestResetSchema = z.object({
  email: emailField,
});
export type RequestResetInput = z.infer<typeof RequestResetSchema>;

export const ResetPasswordWithTokenSchema = z.object({
  token: z.string().uuid('Token invalido'),
  newPassword: z.string().min(8, 'La contrasena debe tener al menos 8 caracteres'),
});
export type ResetPasswordWithTokenInput = z.infer<typeof ResetPasswordWithTokenSchema>;
